import initCommon from './application.js'
import initSwiper from './initializers/Swiper.js'

const initStatic = () => {
  initCommon()
  initSwiper()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStatic)
} else {
  initStatic()
}
